module.exports = __webpack_public_path__ + "static/img/key4lead_logo_image_blue_background.bccfdbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/key4lead_logo_image_blue_background.png
// module id = HkKC
// module chunks = 1